// removed by extract-text-webpack-plugin
module.exports = {"budgetComponentWrapper":"budgetComponentWrapper__3Bh97","budgetWrapper":"budgetWrapper__1EAas","budgetHeading":"budgetHeading__27Bp9","projectWrapper":"projectWrapper__22DLY","projectPrice":"projectPrice__2I1m1","project":"project__2XXUp"};


//////////////////
// WEBPACK FOOTER
// ./components/budgetSource/style.scss
// module id = zgDO
// module chunks = 0 2